import Utils from '@/ecm/common/Utils'
export default class FilterItem {
    constructor () {
        this.uuid = Utils.object.getUUID()
        this.fieldTitle = ''
        this.fieldValues = []
    }
}
